/* eslint-disable global-require */
module.exports = {
  languages: [
    { value: 'en', text: 'English' },
    { value: 'es', text: 'Español' }
  ]
}
